module.exports = __webpack_public_path__ + "img/categoria-2.424e33d6.png";